import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "color", "hollow", "role", "aria-label"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { USE_COLOR_ALIAS_MAP } from '../Tag/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
// StatusDot['use'] is the same as Tag['use'] which excludes koala & heffalump
const colorMapping = {
  lorax: 'fill-accent-orange-default',
  norman: 'fill-accent-magenta-default',
  olaf: 'icon-core-subtle',
  pantera: 'fill-accent-neutral-default',
  sorbet: 'fill-accent-light-orange-default',
  thunderdome: 'fill-accent-purple-default',
  // default, disabled, paused, draft, primary
  default: 'icon-core-disabled',
  // oz, active, success, sent, published
  oz: 'fill-accent-green-default',
  // marigold, warning, inReview, scheduled
  marigold: 'fill-accent-yellow-default',
  // candy-apple, danger, removed, cancelled, error
  'candy-apple': 'fill-accent-red-default',
  // calypso, info
  calypso: 'fill-accent-blue-default'
};
export const getColorToken = (use, color) => {
  if (color) {
    return color;
  } else if (use in colorMapping) {
    return colorMapping[use];
  } else {
    const key = USE_COLOR_ALIAS_MAP[use];
    return colorMapping[key];
  }
};
export const StyledStatusDot = styled.span.withConfig({
  displayName: "StatusDot__StyledStatusDot",
  componentId: "sc-1sx5ljm-0"
})(({
  $use,
  $color,
  $hollow,
  $cssStyles,
  theme
}) => {
  const computedColorToken = getColorToken($use, $color);
  return Object.assign({
    borderRadius: theme.borderRadius['full'],
    display: 'inline-block',
    marginRight: theme.space['200'],
    // Fix for https://git.hubteam.com/HubSpot/UIComponents/issues/12742
    aspectRatio: '1 / 1'
  }, $hollow ? {
    borderBlockWidth: theme.borderWidth['200'],
    borderInlineWidth: theme.borderWidth['200'],
    borderBlockStyle: 'solid',
    borderInlineStyle: 'solid',
    borderBlockColor: theme.color[computedColorToken],
    borderInlineColor: theme.color[computedColorToken]
  } : {
    backgroundColor: theme.color[computedColorToken]
  }, {
    '&&': {
      /* override competing rule when used as a dropdown option avatar */
      blockSize: '10px',
      inlineSize: '10px'
    }
  }, $cssStyles);
});
export const StatusDot = _ref => {
  let {
      use = 'info',
      color,
      hollow = false,
      role,
      'aria-label': ariaLabel
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledStatusDot, Object.assign({
    $use: use,
    $color: color,
    $hollow: hollow,
    $cssStyles: cssStyles,
    role: role,
    "aria-label": ariaLabel
  }, domProps));
};